/// <reference path="./_references.ts"/>

module App.Administrative {
	angular
		.module('administrative', [
			'chart.js',
			'administrative.inventory',
			'administrative.purchase-order',
			'administrative.reviews',
			'administrative.send-invoice',
			'administrative.tags',
			'administrative.upload-photos',
			'administrative.vendor-inventory',
		])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.administrative', {
					url: 'administrative',
					data: {
						title: 'Administrative',
					},
					views: {
						'content@': {
							controller: 'AdministrativeController',
							controllerAs: 'ctrl',
							templateUrl: 'html/administrative/administrative.html',
						},
					},
				});
		}])
		.service('AdministrativeService', AdministrativeService.Factory())
		.controller('AdministrativeController', AdministrativeController);
}